export enum TokenAddEditMode {
  ADD_USER = 'add_user',
  ADD_INTEGRATION = 'add_integration',
  EDIT_INTEGRATION = 'edit_integration'
}

export interface TokenAddEditDialogMeta {
  mode: TokenAddEditMode;
  tokenId?: string;
}
